export default "__VITE_ASSET__f7d4b854__"